export default __webpack_public_path__ + "static/media/techno.6c7e120a.svg";